import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import { CustomTab } from '../../../components'
import { Box } from '@mui/material';

const ImportTabScreen = () => {
  const navigate = useNavigate();
  return (
    <Box mt={-2}>
      <CustomTab
        panels={[
          {
            name: "Comercios",
            route: '/importar/comercios',
            onChange: () => navigate('comercios'),
            content: <Outlet />
          },
          {
            name: "Puntos de Venta",
            route: '/importar/puntos_de_venta',
            onChange: () => navigate('puntos_de_venta'),
            content: <Outlet />
          },
        ]}
      />
    </Box>
  )
}

export default ImportTabScreen